import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardsState } from './dashboards.state';
import { NgxsModule } from '@ngxs/store';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NgxsModule.forFeature([DashboardsState])
  ]
})
export class DashboardsStoreModule { }
